import React from "react";
import { AdditionalAutoEnrollmentContainer } from "../../../containers";

const AdditionalAutoEnrollment = (props) => {
  return <AdditionalAutoEnrollmentContainer {...props} />;
};

export default AdditionalAutoEnrollment;
